"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { getCurrencyFormatted, getUsersList } from "@/lib/app";
import { getRoute } from "@/lib/routes";
import { useAppStore } from "@/stores";
import { NestedUser } from "@revelate/types";
import { ChevronRight } from "lucide-react";
import { useLocation } from "wouter";

interface RecentSalesProps {
  scopedUsers: NestedUser[];
  projectedUsers: NestedUser[];
}

// FIXME: Rename to CommissionsPerEmployee
export function RecentSales({
  scopedUsers,
  projectedUsers,
}: RecentSalesProps) {
  const [, setLocation] = useLocation();
  const { companyCurrency } = useAppStore(state => state);

  return (
    <div className="space-y-7">
      {getUsersList(scopedUsers, projectedUsers)?.map((user) => (
        <div className="flex flex-row justify-between items-center" key={user.id}>
          {/* Left */}
          <div className="flex flex-row items-center">
            {/* Image */}
            <Avatar className="h-10 w-10">
              <AvatarImage src={user.avatar} alt="Avatar" />
              <AvatarFallback>{user.avatar_fallback}</AvatarFallback>
            </Avatar>

            {/* Name and forecast */}
            <div className="ml-4 space-y-1">
              <p className="text-sm font-medium leading-none">
                {user.name}
              </p>
              <p className="text-sm">
                <span>
                  {getCurrencyFormatted(user.valueProjected, companyCurrency?.code)}
                </span>{" "}
                <span className="text-gray-500">
                  forecasted
                </span>
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="flex flex-row items-center">
            {/* Earned */}
            <div className="flex flex-col items-end">
              <div className="text-sm font-medium">
                {getCurrencyFormatted(user.value, companyCurrency?.code)}
              </div>
              <span className="text-sm text-gray-500">
                earned
              </span>
            </div>

            {/* CTA */}
            <div className="ml-3 font-medium">
              <Button
                onClick={() =>
                  setLocation(getRoute("dashboard", "user", user.id))
                }
                variant="outline"
                size="icon-sm"
              >
                <ChevronRight className="h-3.5 w-3.5 text-gray-500" strokeWidth="2px" />
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
